exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer {\n  background-color: #ddddde !important;\n  color: #6e6e6e !important;\n  position: relative;\n  border-top: solid 3px rgba(186, 98, 0, 0.4);\n  padding: 1rem;\n}\n\n.footer a {\n  color: #797979 !important;\n}\n\n.footer a:hover {\n  color: #dd5106 !important;\n}\n@media only screen and (max-width: 880px) {\n  .list-inline .list-inline-item {\n    display: block;\n  }\n}\n", ""]);

// exports
